import React from 'react';
import { ContextWidget } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { PageMembershipMatchingRuleSettingsBlock } from '../../_blocks/PageMembershipMatchingRuleSettings/PageMembershipMatchingRuleSettingsBlock';
import { DefaultContextWidget } from '../_utils/asDefaultWidget';

export type PageMembershipMatchingRuleSettingsWidget = ContextWidget<
  PageMembershipMatchingRuleSettingsBlock,
  WidgetType.pagemembershipmatchingrulesettings
>;

export function PageMembershipMatchingRuleSettingsWidget(props: PageMembershipMatchingRuleSettingsWidget) {
  const { t } = useSonTranslation('PageMembershipMatchingRuleSettings');
  return <DefaultContextWidget icon={Icons.SETTINGS} title={t('widget.headline')} {...props} />;
}
